<template>
	<svg
		@click="trigger"
		class="searchPage__searchIcon"
		xmlns="http://www.w3.org/2000/svg"
		width="30"
		height="34"
		viewBox="0 0 16.555 17.274"
	>
		<g id="Group_15" data-name="Group 15" transform="translate(-1829.81 -53)">
			<g
				id="Ellipse_1"
				data-name="Ellipse 1"
				transform="translate(1832.896 53)"
				fill="none"
				stroke="#000"
				stroke-width="1.25"
			>
				<circle cx="6.735" cy="6.735" r="6.735" stroke="none"></circle>
				<circle cx="6.735" cy="6.735" r="6.11" fill="none"></circle>
			</g>
			<path
				id="Path_22"
				data-name="Path 22"
				d="M1836.189,65l-5.287,5.287"
				transform="translate(-0.65 -0.455)"
				fill="none"
				stroke="#000"
				stroke-width="1.25"
			></path>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'SearchIcon',

	methods: {
		trigger() {
			this.$emit('search');
		},
	},
};
</script>
